"use strict";
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const ViewDate = (props) => {
  const { className, size = IconSize.Medium, color = "inherit", ...rest } = props;
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    /* @__PURE__ */ React.createElement("path", { d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z", opacity: 0.6 }),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        d: "M13.017 4.544A11.829 11.829 0 0 0 1 12a11.819 11.819 0 0 0 22 0 11.835 11.835 0 0 0-.921-1.85c-.9.54-1.953.85-3.079.85a5.983 5.983 0 0 1-2.205-.418A4.998 4.998 0 0 1 12 17a4.999 4.999 0 0 1-3.536-8.536 5 5 0 0 1 4.954-1.259 5.983 5.983 0 0 1-.401-2.66Z"
      }
    ),
    /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M19 10a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm-.5-8v3.25l.2.15 2 1.5.6-.8-1.8-1.35V2h-1Z" })
  );
};
export default ViewDate;
